/* PDP Video Carousel — popup player + seamless infinite loop on mobile.

   Each [data-mm-vc] root is self-contained: tiles clone their hidden <template>
   payload into the shared modal on click. On mobile the tile set is cloned on
   both sides; the loop is re-centered when scrolling settles (snap momentarily
   disabled) so the wrap is invisible and momentum never fights the JS. */
(function () {
  if (window.__mmVcInit) return; // double-include guard — this file
  window.__mmVcInit = true; // can now load from more than one
  // section on the same page (the PDP
  // hero's own video carousel AND
  // sections/pdp-video-carousel.liquid)
  var MOBILE_MQ = "(max-width: 699px)";
  var CLONE_SETS = 2; // copies of the set on each side → plenty of fling runway

  function initSection(root) {
    if (!root || root.getAttribute("data-mm-vc-bound") === "1") return;
    root.setAttribute("data-mm-vc-bound", "1");

    var modal = root.querySelector("[data-mm-vc-modal]");
    var body = root.querySelector("[data-mm-vc-body]");
    var track = root.querySelector("[data-mm-vc-track]");
    var viewport = root.querySelector(".mm-vc__viewport");
    var prevBtn = root.querySelector("[data-mm-vc-prev]");
    var nextBtn = root.querySelector("[data-mm-vc-next]");
    var mPrevBtn = root.querySelector("[data-mm-vc-mprev]");
    var mNextBtn = root.querySelector("[data-mm-vc-mnext]");
    var deskMq = window.matchMedia
      ? window.matchMedia("(min-width: 700px)")
      : { matches: false };
    var lastFocus = null;
    var scrollLockY = 0;
    var isOpen = false;

    // Open/close is a spring (mm-spring.js MMSpring.modal): fades/scales in,
    // swipe the deck down to close, and reopening mid-close reverses it.
    // Without MMSpring the CSS keyframes run and close is instant.
    var deck = modal ? modal.querySelector(".mm-vc__deck") : null;
    var backdrop = modal ? modal.querySelector(".mm-vc__backdrop") : null;
    var motion = null;
    function getMotion() {
      if (!motion && window.MMSpring && deck) {
        deck.style.animation = "none";
        if (backdrop) backdrop.style.animation = "none";
        motion = MMSpring.modal(deck, {
          scrim: backdrop,
          onDismiss: closeModal,
          onClosed: finishClose,
        });
      }
      return motion;
    }

    /* ── Inline preview: tiles with data-mm-vc-src play a muted, looping <video> while
       they're near the viewport (and the tab is visible). Tapping a tile still opens
       the popup, which plays with sound. The <video> is created/removed on demand so
       only a few streams run at once; skipped for reduced-motion / data-saver / slow nets. */
    (function () {
      if (!track || !("IntersectionObserver" in window)) return;
      var reduce =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var slow =
        window.mmSlowNet === true ||
        (navigator.connection && navigator.connection.saveData);
      if (reduce || slow) return;
      function start(tile) {
        if (tile.__mmPv) return;
        var src = tile.getAttribute("data-mm-vc-src");
        if (!src) return;
        var v = document.createElement("video");
        v.className = "mm-vc__preview";
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.autoplay = true;
        v.preload = "auto";
        v.setAttribute("muted", "");
        v.setAttribute("playsinline", "");
        v.setAttribute("aria-hidden", "true");
        var img = tile.querySelector(".mm-vc__poster");
        if (img && img.tagName === "IMG") v.poster = img.currentSrc || img.src;
        v.src = src;
        v.addEventListener("playing", function () {
          tile.classList.add("is-previewing");
        });
        tile.insertBefore(v, tile.firstChild);
        tile.__mmPv = v;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      function stop(tile) {
        var v = tile.__mmPv;
        if (!v) return;
        v.pause();
        v.removeAttribute("src");
        v.load();
        if (v.parentNode) v.parentNode.removeChild(v);
        tile.__mmPv = null;
        tile.classList.remove("is-previewing");
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !document.hidden) start(e.target);
            else stop(e.target);
          });
        },
        { root: null, rootMargin: "0px 120px", threshold: 0.25 },
      );
      function watch() {
        track.querySelectorAll("[data-mm-vc-src]").forEach(function (t) {
          if (!t.__mmWatched) {
            t.__mmWatched = true;
            io.observe(t);
          }
        });
      }
      watch();
      if ("MutationObserver" in window)
        new MutationObserver(watch).observe(track, {
          childList: true,
          subtree: true,
        });
      document.addEventListener("visibilitychange", function () {
        if (!document.hidden) return;
        track.querySelectorAll("[data-mm-vc-src]").forEach(stop);
      });
    })();

    /* ── Popup: swipeable deck ─────────────────────────
       Every video is a slide in a horizontal center-snap scroller —
       swipe (or arrow keys) moves between them without closing. Only
       the focused slide's media plays. */
    var activeSlideIdx = -1;
    var mdots = null;

    function payloadIds() {
      // Originals only — clone cells carry data-mm-vc-clone
      return Array.prototype.map.call(
        root.querySelectorAll(
          ".mm-vc__cell:not([data-mm-vc-clone]) [data-mm-vc-open]",
        ),
        function (b) {
          return b.getAttribute("data-mm-vc-open");
        },
      );
    }

    function buildSlides(openId) {
      var ids = payloadIds();
      // Launcher pills can carry a payload that isn't a tile — lead with it
      if (openId && ids.indexOf(openId) === -1) ids.unshift(openId);
      body.innerHTML = "";
      ids.forEach(function (pid) {
        var tpl =
          root.querySelector('[data-mm-vc-payload="' + pid + '"]') ||
          document.querySelector('[data-mm-vc-payload="' + pid + '"]');
        if (!tpl) return;
        var li = document.createElement("li");
        li.className = "mm-vc__slide";
        var card = document.createElement("article");
        card.className = "mm-vc__slide-card";
        card.appendChild(tpl.content.cloneNode(true));

        // The caption + product + CTA live in the payload's panel, which the
        // CSS lays over the bottom of the footage on a rising gradient
        // (TikTok-style, by request 2026-10-25).
        var player = card.querySelector(".mm-vc__player");
        var panel = card.querySelector(".mm-vc__panel");
        var cap = root.querySelector(
          '[data-mm-vc-open="' + pid + '"] .mm-vc__cap',
        );
        if (cap && cap.textContent.trim()) {
          if (!panel) {
            panel = document.createElement("div");
            panel.className = "mm-vc__panel";
            card.appendChild(panel);
          }
          var title = document.createElement("div");
          title.className = "mm-vc__slide-title";
          title.textContent = cap.textContent.trim();
          panel.insertBefore(title, panel.firstChild);
        }
        if (player) {
          // "Sponsored" label, top-right; the (i) toggles the disclosure note.
          var spons = document.createElement("div");
          spons.className = "mm-vc__spons";
          spons.innerHTML =
            'Sponsored<button type="button" class="mm-vc__spons-i" aria-label="About sponsored posts" aria-expanded="false"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="11" x2="12" y2="16.5"></line><circle cx="12" cy="7.5" r=".6" fill="currentColor"></circle></svg></button><span class="mm-vc__spons-tip" role="note" hidden>Some posts may be sponsored or compensated.</span>';
          (function (btn, tip) {
            var t = null;
            btn.addEventListener("click", function () {
              var show = tip.hidden;
              tip.hidden = !show;
              btn.setAttribute("aria-expanded", show ? "true" : "false");
              clearTimeout(t);
              if (show)
                t = setTimeout(function () {
                  tip.hidden = true;
                  btn.setAttribute("aria-expanded", "false");
                }, 4000);
            });
          })(
            spons.querySelector("button"),
            spons.querySelector(".mm-vc__spons-tip"),
          );
          player.appendChild(spons);
          // Reels-style chrome for native videos: mute chip + paused glyph
          if (player.querySelector("video")) {
            var mute = document.createElement("button");
            mute.type = "button";
            mute.className = "mm-vc__mute";
            mute.setAttribute("aria-label", "Toggle sound");
            mute.innerHTML =
              '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor" stroke="none"></polygon><path class="mm-vc__mute-wave" d="M15.5 8.5a5 5 0 0 1 0 7"></path><line class="mm-vc__mute-x" x1="15" y1="9" x2="21" y2="15"></line><line class="mm-vc__mute-x" x1="21" y1="9" x2="15" y2="15"></line></svg>';
            (function (p) {
              mute.addEventListener("click", function () {
                var v = p.querySelector("video");
                if (!v) return;
                v.muted = !v.muted;
                if (v.paused) v.play().catch(function () {});
              });
            })(player);
            player.appendChild(mute);
            var pp = document.createElement("span");
            pp.className = "mm-vc__pp";
            pp.innerHTML =
              '<span><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="7 4 20 12 7 20 7 4"></polygon></svg></span>';
            player.appendChild(pp);
          }
        }
        li.appendChild(card);
        body.appendChild(li);
      });
      // Product card after the last video: swipe past the end → buy
      var endTpl = root.querySelector("template[data-mm-vc-endcard]");
      if (endTpl && ids.length) {
        var endLi = document.createElement("li");
        endLi.className = "mm-vc__slide mm-vc__slide--product";
        var endCard = document.createElement("article");
        endCard.className = "mm-vc__slide-card mm-vc__endcard";
        endCard.appendChild(endTpl.content.cloneNode(true));
        endLi.appendChild(endCard);
        body.appendChild(endLi);
      }
      // Defuse every player until its slide becomes active
      body.querySelectorAll("video").forEach(function (v) {
        v.removeAttribute("autoplay");
        v.preload = "none";
      });
      body.querySelectorAll("iframe").forEach(function (f) {
        f.setAttribute("data-mm-vc-src", f.getAttribute("src") || "");
        f.removeAttribute("src");
      });
      return ids;
    }

    function buildModalDots(n) {
      mdots = modal ? modal.querySelector("[data-mm-vc-mdots]") : null;
      if (!mdots) return;
      mdots.innerHTML = "";
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var d = document.createElement("span");
        d.className = "mm-vc__dot";
        mdots.appendChild(d);
      }
    }

    function slides() {
      return body ? body.querySelectorAll(".mm-vc__slide") : [];
    }

    function scrollToSlide(i, smooth) {
      var s = slides()[i];
      if (!s) return;
      var left = s.offsetLeft - (body.clientWidth - s.offsetWidth) / 2;
      if (smooth) body.scrollTo({ left: left, behavior: "smooth" });
      else body.scrollLeft = left;
    }

    function activeIndex() {
      var list = slides();
      var mid = body.scrollLeft + body.clientWidth / 2;
      var best = 0,
        bestD = Infinity;
      for (var i = 0; i < list.length; i++) {
        var c = list[i].offsetLeft + list[i].offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) {
          bestD = d;
          best = i;
        }
      }
      return best;
    }

    function deactivateMedia(slide) {
      var v = slide.querySelector("video");
      if (v) v.pause();
      var f = slide.querySelector("iframe");
      if (f && f.getAttribute("src")) f.removeAttribute("src");
    }

    function activateMedia(slide) {
      var video = slide.querySelector("video.mm-vc__video");
      var iframe = slide.querySelector("iframe.mm-vc__iframe");
      var playerBox = slide.querySelector(".mm-vc__player");
      // Fit the player to the source's true aspect ratio (portrait stays
      // tall, landscape stays wide). Card width is fixed, so this only
      // changes height — the deck never shifts horizontally.
      var fitPlayer = function () {
        var vw = video && video.videoWidth,
          vh = video && video.videoHeight;
        if (playerBox && video && vw > 0 && vh > 0) {
          playerBox.style.setProperty("--mm-vc-ar", (vw / vh).toFixed(4));
        } else if (playerBox && iframe) {
          playerBox.style.setProperty("--mm-vc-ar", "16 / 9");
        }
      };
      if (iframe) {
        if (!iframe.getAttribute("src"))
          iframe.setAttribute(
            "src",
            iframe.getAttribute("data-mm-vc-src") || "",
          );
        fitPlayer();
      }
      if (video) {
        video.controls = false; // reels-style: tap toggles play, mute chip top-left
        video.loop = true;
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
        video.setAttribute("x-webkit-airplay", "deny");
        try {
          video.disablePictureInPicture = true;
        } catch (e) {}
        try {
          video.disableRemotePlayback = true;
        } catch (e) {}
        if (!video.__mmVcBound) {
          video.__mmVcBound = true;
          video.addEventListener("click", function () {
            if (video.paused) video.play().catch(function () {});
            else video.pause();
          });
          video.addEventListener("play", function () {
            if (playerBox) playerBox.classList.remove("mm-vc__player--paused");
          });
          video.addEventListener("pause", function () {
            if (playerBox) playerBox.classList.add("mm-vc__player--paused");
          });
          video.addEventListener("volumechange", function () {
            var m = slide.querySelector(".mm-vc__mute");
            if (m) m.classList.toggle("mm-vc__mute--muted", video.muted);
          });
        }
        if (video.readyState >= 1) fitPlayer();
        video.addEventListener("loadedmetadata", fitPlayer);
        video.addEventListener("loadeddata", fitPlayer);
        // buildSlides defuses every player to preload=none; the active slide
        // should buffer ahead aggressively while it plays.
        video.preload = "auto";
        var playP = video.play();
        if (playP && playP.catch) {
          // If the browser blocks audible autoplay, fall back to muted so it still plays.
          playP.catch(function () {
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      }
    }

    function syncSlides() {
      var list = slides();
      if (!list.length) return;
      var idx = activeIndex();
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle("mm-vc__slide--active", i === idx);
      }
      if (mdots) {
        for (var j = 0; j < mdots.children.length; j++) {
          mdots.children[j].classList.toggle("mm-vc__dot--on", j === idx);
        }
      }
      if (idx !== activeSlideIdx) {
        for (var k = 0; k < list.length; k++) {
          if (k !== idx) deactivateMedia(list[k]);
        }
        activateMedia(list[idx]);
        activeSlideIdx = idx;
      }
      if (mPrevBtn) mPrevBtn.disabled = idx <= 0;
      if (mNextBtn) mNextBtn.disabled = idx >= list.length - 1;
    }

    var mhint = modal ? modal.querySelector("[data-mm-vc-mhint]") : null;
    var hintArmed = false;

    var slideTick = false;
    if (body) {
      body.addEventListener(
        "scroll",
        function () {
          // First real swipe dismisses the hint (armed after the programmatic
          // positioning on open, so that initial jump doesn't kill it)
          if (hintArmed && mhint && !mhint.hidden) mhint.hidden = true;
          if (slideTick) return;
          slideTick = true;
          requestAnimationFrame(function () {
            slideTick = false;
            syncSlides();
          });
        },
        { passive: true },
      );
    }

    function openModal(id) {
      if (!modal || !body) return;
      var ids = buildSlides(id);
      if (!ids.length) return;

      // One-time "tap to view product" cue on the tile strip — dismissed for
      // good the first time any tile is opened, so it never nags on repeat.
      var taphint = root.querySelector("[data-mm-vc-taphint]");
      if (taphint) taphint.hidden = true;

      // Stop every warm-up fetch — the real player owns the bandwidth now.
      // Bytes the warmers already buffered stay in the HTTP cache and are
      // reused by the cloned player below (see the warm-up block near EOF).
      if (window.__mmVcWarm) window.__mmVcWarm.abortAll();

      // CTA labels flagged auto (no editor override) mirror the page's main
      // Add-to-Cart button text — read at open time so client-side discount
      // rewrites (e.g. Kaching) are already applied.
      var atcSrc =
        document.querySelector(".mm-buybox__atc .mm-btn__label") ||
        document.querySelector(".mm-buybox__atc") ||
        document.querySelector("[data-m15-atc] [data-m15-cta-label]");
      var atcText =
        atcSrc && atcSrc.textContent
          ? atcSrc.textContent.replace(/\s+/g, " ").trim()
          : "";
      if (atcText.indexOf("{") !== -1) atcText = ""; // unresolved {discount…} token — keep the fallback
      if (atcText) {
        body.querySelectorAll("[data-mm-vc-cta-auto]").forEach(function (cta) {
          var lbl = cta.querySelector(".mm-btn__label") || cta;
          lbl.textContent = atcText;
        });
      }

      // Kaching deals apply at cart and are invisible to Liquid, so the
      // server-rendered price has no compare-at. When the page's preselected
      // deal matches this popup's product (variant cents === deal.orig, so
      // featured-other-product tiles are left alone), show the deal price
      // with the original struck through. mmKachingDeal/mmDiscountMoney are
      // globals from pdp-trimmer.js (loaded on every PDP by pdp-header).
      try {
        var deal = typeof mmKachingDeal === "function" ? mmKachingDeal() : null;
        if (deal) {
          body
            .querySelectorAll(".mm-vc__product-price[data-mm-vc-price]")
            .forEach(function (wrap) {
              if (
                parseInt(wrap.getAttribute("data-mm-vc-price"), 10) !==
                deal.orig
              )
                return;
              var priceEl = wrap.querySelector(".mm-vc__price");
              if (!priceEl) return;
              priceEl.textContent = mmDiscountMoney(deal.orig - deal.save);
              var cmp = wrap.querySelector(".mm-vc__compare");
              if (!cmp) {
                cmp = document.createElement("s");
                cmp.className = "mm-vc__compare";
                wrap.appendChild(cmp);
              }
              cmp.textContent = mmDiscountMoney(deal.orig);
            });
        }
      } catch (e) {
        /* price enhancement must never block the video */
      }

      if (!isOpen) {
        lastFocus = document.activeElement;
        // Hard page lock — plain overflow:hidden isn't enough on iOS, the
        // page still rubber-bands behind the deck while swiping
        scrollLockY = window.scrollY || window.pageYOffset || 0;
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = -scrollLockY + "px";
        document.body.style.left = "0";
        document.body.style.right = "0";
      }
      modal.hidden = false;
      isOpen = true;
      var m = getMotion();
      if (m) m.open();

      buildModalDots(slides().length);
      if (mPrevBtn) mPrevBtn.hidden = ids.length < 2;
      if (mNextBtn) mNextBtn.hidden = ids.length < 2;
      if (mhint) mhint.hidden = ids.length < 2;
      hintArmed = false;
      activeSlideIdx = -1;
      var idx = Math.max(0, ids.indexOf(id));
      // Wait a frame so the deck has layout, then land on the chosen slide
      requestAnimationFrame(function () {
        scrollToSlide(idx, false);
        syncSlides();
      });
      setTimeout(function () {
        hintArmed = true;
      }, 250);

      body.querySelectorAll("[data-mm-vc-cta-close]").forEach(function (a) {
        a.addEventListener("click", function () {
          closeModal();
        });
      });
      var closeBtn = modal.querySelector(".mm-vc__close");
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function closeModal() {
      if (!modal || !isOpen) return;
      isOpen = false;
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      window.scrollTo({ top: scrollLockY, left: 0, behavior: "instant" });
      if (body) {
        // Silence right away; the cards stay on screen while the spring fades them
        body.querySelectorAll("video").forEach(function (v) {
          try {
            v.pause();
          } catch (e) {}
        });
        body.querySelectorAll("iframe").forEach(function (f) {
          f.removeAttribute("src");
        });
      }
      if (lastFocus && lastFocus.focus)
        lastFocus.focus({ preventScroll: true });
      var m = getMotion();
      if (m) m.close();
      else finishClose();
    }
    // Runs once the close has settled (or at once without MMSpring)
    function finishClose() {
      if (isOpen) return; // reopened mid-close
      modal.hidden = true;
      if (body) {
        // Explicitly silence every player BEFORE detaching — a removed
        // <video> keeps playing (and looping) as long as JS references
        // (our listeners) keep it alive; innerHTML='' alone is not enough.
        body.querySelectorAll("video").forEach(function (v) {
          try {
            v.pause();
            v.loop = false;
            v.muted = true;
            v.querySelectorAll("source").forEach(function (s) {
              s.removeAttribute("src");
            });
            v.removeAttribute("src");
            v.load();
          } catch (e) {}
        });
        body.querySelectorAll("iframe").forEach(function (f) {
          f.removeAttribute("src");
        });
        body.innerHTML = "";
      }
      activeSlideIdx = -1;
    }

    // Expose for out-of-carousel launchers (e.g. the buybox
    // "See it in action" pill) — see the [data-mm-vc-launch] delegate below.
    root.__mmVcOpen = openModal;

    /* ── Desktop modal navigation: arrows + click a dimmed neighbor card.
       Mobile keeps swipe untouched (arrows are display:none < 700px and
       the click delegate is gated on the same media query). ── */
    if (mPrevBtn)
      mPrevBtn.addEventListener("click", function () {
        scrollToSlide(Math.max(0, activeIndex() - 1), true);
      });
    if (mNextBtn)
      mNextBtn.addEventListener("click", function () {
        scrollToSlide(Math.min(slides().length - 1, activeIndex() + 1), true);
      });
    if (body) {
      // Capture phase so an inactive card's video/CTA handlers never fire —
      // the first click just brings that card into focus.
      body.addEventListener(
        "click",
        function (e) {
          if (!deskMq.matches) return;
          var slide = e.target.closest
            ? e.target.closest(".mm-vc__slide")
            : null;
          if (!slide || slide.classList.contains("mm-vc__slide--active"))
            return;
          e.preventDefault();
          e.stopPropagation();
          var list = slides();
          var i = Array.prototype.indexOf.call(list, slide);
          if (i >= 0) scrollToSlide(i, true);
        },
        true,
      );
    }

    // Delegated so cloned tiles open too
    if (track) {
      track.addEventListener("click", function (e) {
        var tile = e.target.closest("[data-mm-vc-open]");
        if (tile && track.contains(tile))
          openModal(tile.getAttribute("data-mm-vc-open"));
      });
    }
    if (modal) {
      modal.querySelectorAll("[data-mm-vc-close]").forEach(function (el) {
        el.addEventListener("click", closeModal);
      });
    }
    // The deck can fill the screen (pdp-ask.css), covering the backdrop: a tap
    // on its empty space — not on a card or control — closes like the backdrop.
    if (deck) {
      deck.addEventListener("click", function (e) {
        if (e.target === deck || e.target === body) closeModal();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (!modal || !isOpen) return;
      if (e.key === "Escape") closeModal();
      else if (e.key === "ArrowLeft")
        scrollToSlide(Math.max(0, activeIndex() - 1), true);
      else if (e.key === "ArrowRight")
        scrollToSlide(Math.min(slides().length - 1, activeIndex() + 1), true);
    });

    /* ── Infinite loop (mobile) ────────────────────── */
    var mq = window.matchMedia
      ? window.matchMedia(MOBILE_MQ)
      : { matches: false };
    var looping = false;
    var setW = 0,
      baseLeft = 0,
      endTimer = null;

    function originals() {
      return Array.prototype.filter.call(track.children, function (c) {
        return c.getAttribute("data-mm-vc-clone") !== "1";
      });
    }

    function buildLoop() {
      if (looping || !track) return;
      var cells = originals();
      if (cells.length < 2) return;
      if (track.scrollWidth - track.clientWidth <= 4) return; // no overflow → nothing to loop

      function makeClone(c) {
        var clone = c.cloneNode(true);
        clone.setAttribute("data-mm-vc-clone", "1");
        clone.setAttribute("aria-hidden", "true");
        var btn = clone.querySelector("[data-mm-vc-open]");
        if (btn) btn.setAttribute("tabindex", "-1");
        return clone;
      }

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var s = 0; s < CLONE_SETS; s++) {
        cells.forEach(function (c) {
          before.appendChild(makeClone(c));
          after.appendChild(makeClone(c));
        });
      }
      var firstCloneNode = before.firstChild;
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);

      var firstOriginal = cells[0];
      setW =
        (firstOriginal.offsetLeft - firstCloneNode.offsetLeft) / CLONE_SETS;
      baseLeft = firstOriginal.offsetLeft;
      /* Land with the FIRST video centered in the viewport — center-snap
         would otherwise leave whichever neighbor sits mid-screen in focus */
      track.scrollLeft =
        baseLeft -
        Math.max(0, (track.clientWidth - firstOriginal.offsetWidth) / 2);
      looping = true;
    }

    function teardownLoop() {
      if (!looping || !track) return;
      Array.prototype.slice
        .call(track.querySelectorAll('[data-mm-vc-clone="1"]'))
        .forEach(function (c) {
          track.removeChild(c);
        });
      track.scrollLeft = 0;
      looping = false;
    }

    // Re-center to the original set once scrolling settles — invisible because
    // the clones are identical, and snap is briefly off so there's no fight.
    function normalize() {
      if (!looping || setW <= 0) return;
      var x = track.scrollLeft,
        nx = x;
      while (nx >= baseLeft + setW) nx -= setW;
      while (nx < baseLeft) nx += setW;
      if (Math.abs(nx - x) > 0.5) {
        var prev = track.style.scrollSnapType;
        track.style.scrollSnapType = "none";
        track.scrollLeft = nx;
        requestAnimationFrame(function () {
          track.style.scrollSnapType = prev || "";
        });
      }
    }

    /* ── Swipe focus: the cell nearest the viewport center reads as
       active (dim/scale handled in CSS, mobile only). Clones count too,
       so the highlight never blinks across the loop seam. ── */
    var dots = root.querySelectorAll("[data-mm-vc-dots] .mm-vc__dot");
    function syncActive() {
      if (!track) return;
      var rect = track.getBoundingClientRect();
      var mid = rect.left + rect.width / 2;
      var best = null,
        bestD = Infinity;
      Array.prototype.forEach.call(track.children, function (cell) {
        var r = cell.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) {
          bestD = d;
          best = cell;
        }
      });
      Array.prototype.forEach.call(track.children, function (cell) {
        cell.classList.toggle("mm-vc__cell--active", cell === best);
      });
      /* Progress dots: clone sets are full in-order copies, so the child
         index modulo the original count maps any clone back to its video */
      if (dots.length && best) {
        var setLen = originals().length;
        var childIdx = Array.prototype.indexOf.call(track.children, best);
        var origIdx = setLen > 0 ? childIdx % setLen : -1;
        dots.forEach(function (d, i) {
          d.classList.toggle("mm-vc__dot--on", i === origIdx);
        });
      }
    }

    var activeTick = false;
    function onScroll() {
      /* updateArrows moved into the rAF (2026-08-16) so its 3-4 layout reads
         coalesce to once per frame with syncActive instead of running on every
         scroll event during a fling. Arrow state one frame late is imperceptible. */
      if (!activeTick) {
        activeTick = true;
        requestAnimationFrame(function () {
          activeTick = false;
          syncActive();
          updateArrows();
        });
      }
      if (!looping) return;
      if (endTimer) clearTimeout(endTimer);
      endTimer = setTimeout(normalize, 110);
    }

    /* ── Desktop arrows ────────────────────────────── */
    function scrollByTile(dir) {
      if (!track) return;
      var cell = track.querySelector(".mm-vc__cell");
      var step = cell
        ? cell.getBoundingClientRect().width + 14
        : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * step, behavior: "smooth" });
    }
    function updateArrows() {
      if (!track || !viewport) return;
      var overflow = track.scrollWidth - track.clientWidth > 4;
      viewport.classList.toggle("mm-vc__viewport--has-arrows", overflow);
      if (prevBtn) {
        prevBtn.hidden = !overflow;
        prevBtn.disabled = !looping && track.scrollLeft <= 2;
      }
      if (nextBtn) {
        nextBtn.hidden = !overflow;
        nextBtn.disabled =
          !looping &&
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
    }
    if (prevBtn)
      prevBtn.addEventListener("click", function () {
        scrollByTile(-1);
      });
    if (nextBtn)
      nextBtn.addEventListener("click", function () {
        scrollByTile(1);
      });
    if (track) track.addEventListener("scroll", onScroll, { passive: true });

    /* Armed when the strip comes within 200px of the viewport (2026-10-28):
       buildLoop clones every tile four times and syncActive/updateArrows
       measure every cell, so running them at script start meant forced
       layouts of a still-loading page for a strip that sits below the buy
       box. Breakpoint/resize changes before that point are no-ops — arming
       reads the current state anyway. */
    var armed = false;
    function syncMode() {
      if (!armed) return;
      if (mq.matches) buildLoop();
      else teardownLoop();
      updateArrows();
      syncActive();
    }
    if (mq.addEventListener) mq.addEventListener("change", syncMode);
    else if (mq.addListener) mq.addListener(syncMode);

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (looping) teardownLoop();
        syncMode();
      }, 200);
    });

    function arm() {
      if (armed) return;
      armed = true;
      syncMode();
    }
    if (track && "IntersectionObserver" in window) {
      var armIo = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              armIo.disconnect();
              arm();
              return;
            }
          }
        },
        { rootMargin: "200px 0px" },
      );
      armIo.observe(track);
    } else {
      arm();
    }
  }

  function initAll() {
    document.querySelectorAll("[data-mm-vc]").forEach(initSection);
  }
  // Late-injected carousels (home-rvt-hero loads the PDP hero after page load) call this to bind.
  window.mmVcInitAll = initAll;

  /* ── Warm-up: make "See it in action" videos start fast (2026-08-16) ──
     The payloads live in inert <template>s, so a video's first byte used to
     arrive only AFTER the modal was open — that gap is the spinner shoppers
     saw. This block front-runs the fetch on user signals while spending
     nothing at initial page load:
       · a launcher pill on screen warms its video's METADATA (moov atom,
         tens of KB) + poster — armed ~1.5s after window load, so it can
         never compete with the LCP;
       · hovering/focusing any launcher or tile warms metadata;
       · pointerdown/touchstart upgrades to FULL buffering (preload=auto) —
         the shopper is committing, so the download runs during the tap and
         the modal-open frames;
       · YouTube/Vimeo payloads get origin preconnects instead;
       · warmers are hidden muted <video> elements that are NEVER played,
         capped at 3 (oldest evicted), and all aborted the moment the modal
         opens so they cannot compete with the real player. Re-used bytes
         come from the HTTP cache (Shopify CDN videos are immutable).
     Engines that ignore preload hints (older iOS Safari) simply no-op —
     behavior there is exactly as before. */
  var warm = (function () {
    var MAX_WARM = 3;
    var box = null;
    var warmers = {}; // payload id -> { el, level }
    var order = []; // element-backed warmers only, oldest first

    function holder() {
      if (box) return box;
      box = document.createElement("div");
      box.setAttribute("aria-hidden", "true");
      box.style.cssText =
        "position:fixed;left:-9999px;width:1px;height:1px;overflow:hidden;";
      document.body.appendChild(box);
      return box;
    }
    function tplFor(id) {
      return document.querySelector('[data-mm-vc-payload="' + id + '"]');
    }
    function preconnect(origin) {
      if (document.querySelector('link[data-mm-vc-pc="' + origin + '"]'))
        return;
      var l = document.createElement("link");
      l.rel = "preconnect";
      l.href = origin;
      l.setAttribute("data-mm-vc-pc", origin);
      document.head.appendChild(l);
    }
    function start(id, level) {
      if (!id) return;
      var w = warmers[id];
      if (w) {
        if (level === "auto" && w.el && w.level !== "auto") {
          w.level = "auto";
          w.el.preload = "auto";
        }
        return;
      }
      var tpl = tplFor(id);
      if (!tpl || !tpl.content) return;
      var src = tpl.content.querySelector("video");
      if (!src) {
        // Third-party player: the best we can do is open the connection early.
        var ifr = tpl.content.querySelector("iframe");
        var u = ifr ? ifr.getAttribute("src") || "" : "";
        if (u.indexOf("youtube") !== -1) {
          preconnect("https://www.youtube.com");
          preconnect("https://i.ytimg.com");
        } else if (u.indexOf("vimeo") !== -1) {
          preconnect("https://player.vimeo.com");
        }
        warmers[id] = { el: null, level: level };
        return;
      }
      // The poster is the first thing the shopper sees in the modal — prime it.
      var poster = src.getAttribute("poster");
      if (poster) {
        new Image().src = poster;
      }
      var v = document.createElement("video");
      v.muted = true;
      v.setAttribute("playsinline", "");
      v.preload = level === "auto" ? "auto" : "metadata";
      // Clone the <source> list verbatim so the warmer resolves the SAME file
      // the modal clone will pick (HLS on Safari, MP4 elsewhere) → cache aligns.
      var sources = src.querySelectorAll("source");
      for (var i = 0; i < sources.length; i++) {
        var s = document.createElement("source");
        if (sources[i].getAttribute("src"))
          s.src = sources[i].getAttribute("src");
        if (sources[i].getAttribute("type"))
          s.type = sources[i].getAttribute("type");
        v.appendChild(s);
      }
      if (!v.children.length) {
        if (src.getAttribute("src")) v.src = src.getAttribute("src");
        else return;
      }
      holder().appendChild(v);
      warmers[id] = { el: v, level: level };
      order.push(id);
      if (order.length > MAX_WARM) stop(order.shift());
    }
    function stop(id) {
      var w = warmers[id];
      if (w && w.el) {
        try {
          while (w.el.firstChild) w.el.removeChild(w.el.firstChild);
          w.el.removeAttribute("src");
          w.el.load(); // aborts any in-flight fetch
        } catch (e) {}
        if (w.el.parentNode) w.el.parentNode.removeChild(w.el);
      }
      delete warmers[id];
    }
    function abortAll() {
      while (order.length) stop(order.shift());
      // iframe preconnect markers stay — they are one-time head links.
    }
    return { start: start, abortAll: abortAll };
  })();
  window.__mmVcWarm = warm;

  function warmIdFor(trigger) {
    var id =
      trigger.getAttribute("data-mm-vc-launch") ||
      trigger.getAttribute("data-mm-vc-open") ||
      "";
    if (!id) {
      // Blank launcher opens the first payload — mirror the open delegate.
      var tpl = document.querySelector("[data-mm-vc-payload]");
      id = tpl ? tpl.getAttribute("data-mm-vc-payload") : "";
    }
    return id;
  }
  function warmCurious(e) {
    var t =
      e.target && e.target.closest
        ? e.target.closest("[data-mm-vc-launch],[data-mm-vc-open]")
        : null;
    if (t) warm.start(warmIdFor(t), "metadata");
  }
  function warmCommit(e) {
    var t =
      e.target && e.target.closest
        ? e.target.closest("[data-mm-vc-launch],[data-mm-vc-open]")
        : null;
    if (t) warm.start(warmIdFor(t), "auto");
  }
  document.addEventListener("mouseover", warmCurious);
  document.addEventListener("focusin", warmCurious);
  document.addEventListener("pointerdown", warmCommit, { passive: true });
  document.addEventListener("touchstart", warmCommit, { passive: true });

  // Prime the primary path: once the page has fully loaded (LCP long
  // settled), warm the metadata of any launcher pill actually on screen.
  function armLauncherWarm() {
    var pills = document.querySelectorAll("[data-mm-vc-launch]");
    if (!pills.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          warm.start(warmIdFor(en.target), "metadata");
        });
      },
      { rootMargin: "200px" },
    );
    pills.forEach(function (p) {
      io.observe(p);
    });
  }
  if (document.readyState === "complete") {
    setTimeout(armLauncherWarm, 1500);
  } else {
    window.addEventListener("load", function () {
      setTimeout(armLauncherWarm, 1500);
    });
  }

  /* Launcher pills anywhere on the page: [data-mm-vc-launch="<payload id>"]
     opens that video in the carousel's modal; an empty value opens the
     first video. No-op when no carousel is on the page. */
  document.addEventListener("click", function (e) {
    var launcher = e.target.closest
      ? e.target.closest("[data-mm-vc-launch]")
      : null;
    if (!launcher) return;
    var root = document.querySelector("[data-mm-vc]");
    if (!root || !root.__mmVcOpen) return;
    var id = launcher.getAttribute("data-mm-vc-launch");
    if (!id) {
      var firstTpl = root.querySelector("[data-mm-vc-payload]");
      id = firstTpl && firstTpl.getAttribute("data-mm-vc-payload");
    }
    if (id) root.__mmVcOpen(id);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:unload", function () {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
  });
})();
